import { ExtendedFormattedCalculatorResult } from '../types';
import { AffordabilityCalculatorForm } from '../../types';

export interface ResultsSectionProps {
  financeDetails: Pick<AffordabilityCalculatorForm['financeDetails'], 'financingAmount'>;
  bestProduct: ExtendedFormattedCalculatorResult | null;
  productOptions: ExtendedFormattedCalculatorResult[];
  sortBy: string;
  setSortBy: React.Dispatch<React.SetStateAction<string>>;
}

export enum ResultsSortingTypesEnum {
  initialMonthlyRepaymentsAsc = 'initialMonthlyRepaymentsAsc',
  maxFinancingDesc = 'maxFinancingDesc',
  initialTermAsc = 'initialTermAsc',
  initialRateAsc = 'initialRateAsc',
}
